module.exports = __webpack_public_path__ + "img/7_190.20c40346.png";